module.exports = __webpack_public_path__ + "static/kubernetes-d91337c578758865cbee1f4351d26691.svg";